// TrucksLineupLab.jsx
import NascarLineupLab from "./NascarLineupLab";

export default function TrucksLineupLab() {
  return <NascarLineupLab series="trucks" />;
}